import { useTranslation } from 'react-i18next'
import { AppShell } from '../../components/AppShell'
import { useNetwork } from '../../contexts/NetworkContext'
import { CreateObjectButton } from '@/components/CreateObjectButton'
import { LineItemAttentionCard } from '@/components/LineItemAttentionCard'
import { RecentLineItemsCard } from '@/components/RecentLineItemsCard'
import { StatsPanel } from '@/components/StatsPanel'
import { TaggedLineItemsCard } from '@/components/TaggedLineItemsCard'

/** Every line item in the network, split into time buckets. */
const NETWORK_STATS_QUERY = { all: 'lineItem', groupBy: 'HALF_HOURLY' } as const

export function AdvertisingHomePage() {
  const { t } = useTranslation()
  const { currentNetwork } = useNetwork()
  // A marketplace order belongs to an advertiser, so it's created from one.
  const canCreateOrder = !currentNetwork?.marketplacePlatform

  return (
    <AppShell crumbs={[{ label: t('nav.home') }]}>
      <div className="ad-page">
        <div className="ad-page__header">
          <div className="ad-page__title-block">
            <h1>{t('advertisingHome.title')}</h1>
            <p>{t('advertisingHome.subtitle')}</p>
          </div>
          {canCreateOrder && (
            <div className="ad-page__actions">
              <CreateObjectButton type="order" size="default" />
            </div>
          )}
        </div>

        <div className="flex flex-col gap-4">
          <TaggedLineItemsCard />
          <div className="grid items-start gap-4 2xl:grid-cols-2">
            <LineItemAttentionCard />
            <StatsPanel
              query={NETWORK_STATS_QUERY}
              storageKey="advertising-home"
              defaultRange="30d"
              variant="advertising"
            />
          </div>
          <div className="grid gap-4 lg:grid-cols-2">
            <RecentLineItemsCard sort="createTime" />
            <RecentLineItemsCard sort="updateTime" />
          </div>
        </div>
      </div>
    </AppShell>
  )
}
